<template>

    <div class="blueBg">
        <div class="innerSlide">
            <a v-if="categoryId!==undefined" :href="'/studies-category?id=' + categoryId" class="backTitle pc">
                {{ $t('studies.page.'+categoryName) }}
            </a>
            <a v-else href="/studies-top" class="backTitle pc">
                {{ $t('studies.page.back') }}
            </a>

            <div class="detailContent">
                <div class="detailWrapper">
                    <div class="img sp">
                        <img v-bind:src="backgroundImage" alt="">
                    </div>
                    <div class="textWrapper">
                        <div class="title">{{ $t('studies.title.' + targetid) }}</div>
                        <div class="content" v-html="'' + $t('studies.about.' + targetid)">
                        </div>

                        <a v-on:click="handleOnClick()" class="play">
                            {{ $t('studies.page.play') }}
                        </a>
                    </div>
                    <div class="img pc">
                        <img v-bind:src="backgroundImage" alt="">
                    </div>
                </div>
                <div class="howto">
                    <div class="title">{{ $t('studies.page.howto') }}</div>
                    <p v-html="'' + $t('studies.howto.' + targetid)">
                    </p>
                </div>
            </div>

            <a v-if="categoryId!==undefined" :href="'/studies-category?id=' + categoryId" class="back sp">
                {{ $t('studies.page.'+categoryName) }}
            </a>
            <a v-else href="/studies-top" class="back sp">
                {{ $t('studies.page.back') }}
            </a>
        </div>
    </div>

</template>


<script>
    import languageService from "../../services/LanguageService";
    import AuthUtil from '../../utils/AuthUtil';
    import userService from "../../services/UserService";

    export default {
        name: 'studies-detail',

        components: {
        },

        data() {
            return {
                targetid : 1,
                img : "",
                url : "",
                isAuth: false,
                isOpenImg01Modal: false,
                isOpenImg02Modal: false,
                lang: 'en',
                contentImagePath: '/cai/common/images/info-screen/',
                backgroundImage: '',
                categoryId: '',
                categoryName: ''
            }
        },

        created() {
            this.targetid = this.$route.query.id
            this.img = this.$route.query.img
            this.url = this.$route.query.url
            this.lang = languageService.getCurrentLanguageShortCode();
            this.setBackgroundImage()
            this.categoryId = this.$route.query.categoryId;
            this.categoryName = this.$route.query.categoryName;
        },

        methods: {
            async fetchTransactions() {
                //const responseData = await PayPalService.getListOfTransactions();
                //this.data = responseData.data.agreement_transaction_list;
            },

            async handleOnClick() {
                if (!AuthUtil.isAuth()) {
                    this.$router.push('/studies-error?code=not_login');
                    return;
                }

                this.lang = languageService.getCurrentLanguageShortCode();
                window.open('' + this.url + '?lang=' + this.lang + '&url=' + process.env.MIX_BACKEND_URL, '_blank');
            },
            setBackgroundImage() {
                this.backgroundImage = this.contentImagePath + this.lang + '/' + this.img
            },
        },

        mounted() {
        },

        watch: {
            '$i18n.locale': function(locale) {
                this.lang = languageService.getCurrentLanguageShortCode();
                this.setBackgroundImage()
            }
        }
    }
</script>

<style lang="sass" scoped>
    @import "./assets/css/slick.scss"
    @import "./assets/css/style.scss"
</style>
